import "../books.css";

const one = (
  <div>
    <h2 id="chapterone">Chapter One</h2>

    <p>
      <em>Deus Ex Machina.</em>
    </p>

    <p>God from machine.</p>

    <p>
      In ancient days, when humanity was grounded on Earthen shores and had yet
      to fly even its meager skies, the god was no more than an actor in Greek
      theater, and the machine no more than a simple crane.
    </p>

    <p>
      The real machine is bigger. Much bigger. Bigger than the crane. Bigger
      than the Earth upon which the humble crane stood, bigger even than the sun
      that lit the Earthen skies. And it is sadder. Sadder than even the
      harshest and cruelest tragedy delivered by crane-held gods and designed by
      penship of mortal man. The sadness that clings to the giant hulk of metal
      is a piece of two parts, of two uneven and weighty halves.
    </p>

    <p>
      The first rests entirely upon the lifeless machinery. It has eaten stars
      whole, digesting them whole and leaving only charred dust and utter
      blackness behind. Stardust, once a dream of humankind, now a mere trace of
      its destruction and progress.
    </p>

    <p>
      Yet for all the stars that have passed through the it’s stomach, for all
      the power that runs through its superfluid veins of liquid helium-3, it is
      lifeless. The first sadness that hangs on the machine, however, is made up
      of more than the emptiness of it’s metal frame and the absence of its
      inhabitants. It is made up of the lifelessness in places one considered
      home, from beyond the Magellanic Cloud and past the Sculptor Wall to the
      humble origins of humanity.
    </p>

    <p>
      All their hopes, all their lives, all their last wishes hung onto machine.
      With no other choice presented to them they had given their hopes to the
      holy men. The brightest and most calculating humankind had to offer,
      scientists and engineers from every far off corner of the universe. And
      that is where the first piece of the sadness lays, in the final dreams and
      last hopes of those long gone, for the machine and it’s holy men had
      failed them.
    </p>

    <p>
      The second piece of the sadness rests entirely on the shoulders of the
      last holy man, the final progeny of the high priest, the last man left in
      the entirety of the lonely universe in which the machine and man dwell.
      That is, if you can still call the patchwork of biology and mechanics
      inside the hard exoskeleton of his nanofiber suit human.
    </p>

    <p>
      Three centuries ago the man, then a boy, had woken from his frantically
      self-induced sleep. After three thousand years in the hibe, a period of
      time made just barely possible by the recent and rare advancements in
      biotech, there was nothing waiting for the boy. Nothing but loneliness and
      a near flawless machine set on the scale of stars.
    </p>

    <p>
      Three centuries and no friends. Three centuries and no companion other
      than the hulk of metal on which he lives. And that is the centerpiece of
      the second sadness, three centuries alone and no hope of change for the
      last remnant of man.
    </p>

    <p>
      Three centuries, three stars, and soon to be three attempts, each
      performed with less hope and certainty than the last. Left with nothing to
      which he appends value, all that is left for the boy, now a man, is
      godhood.
    </p>

    <p>
      It is an empty pursuit for the man, for the <em>Deus</em> hopeful. There
      is no ambition in his goal, only a bitter longing. When he thinks about
      himself, a rare habit, he considers it childish. But what else is there
      for him but the machine on which he lives, and to see it working. He
      doesn’t care if it takes the consumption of every star or the destruction
      of the universe, after three centuries alone he’s not sure he cares about
      anything anymore, much less the inanimate bodies of fusion and fire that
      line the perpetual night sky.
    </p>

    <p>
      He had a name once, when he was a boy. It no longer fits him. He does not
      think of himself as <em>Deus</em>; he gives that name to the machine,
      fitting in some ways and less so in others. Rather he does not think of
      himself, or, when he does, for one must think of themselves in interaction
      with the outside, he is merely referred to as the self-entity.
    </p>

    <p>
      To best describe his intentionally unexplored description of self, he is a
      caretaker. An integral piece of the machine on which lives, yet a mere keg
      in the machine of godhood, no more notable than any of the other
      uncountable essential functionaries of the <em>Deus</em>.
    </p>

    <p>
      The caretaker steps forward, into the chamber. His steps are taken with
      trepidation. The hands at his side shake as he enters. He could stop the
      needless movement, the machinery in his body gives him near perfect
      control. But the shaking hands are like heroin through his veins. He needs
      to feel <em>something</em>, regardless of what it is.
    </p>

    <p>
      Eighty-eight years have passed since he last entered this place. It is the
      control room. God’s Seat. <em>De Sede Dei</em>, named in keeping with the
      Latin theme that had given the machine its name. Gel-tech monitors and
      other vestigial apparatuses are held by the numerous maintenance and
      construction contraptions throughout the <em>Deus</em>, but not here.
    </p>

    <p>
      God’s Seat is a small room of near complete darkness. The walls are
      unadorned and basic. Had the room been built by the host of holy men it
      would have been a loftier place. Not extravagant, the holy men’s
      efficiency and obsession with functional design would not allow for that.
      But certainly the room would have been decorated, if only in some small
      and meaningless way.
    </p>

    <p>
      But the caretaker had built this room himself, the crowning gem of the{" "}
      <em>Deus</em>. Every piece of the <em>Deus</em> is a pinnacle of
      scientific discovery and human ingenuity. They all pale in comparison to
      the God’s Seat. The quantum super computer that powers the functionality
      of this room is the size of a large moon, and none of the space is wasted.
    </p>

    <p>
      It’s intended function, explained in the simplest possible sense, akin to
      the relation of baby talk to language, is transcription. A systematic
      assessment and breakdown of the state of the human mind into the
      fundamental particles of the universe, forged and given shape by the power
      of consumed stars.
    </p>

    <p>
      The caretaker had finished the holy men’s work on the sophisticated
      hardware system in only his third decade of awakening. He spent the next
      eight decades implementing quantum algorithms into the system, coding in
      the native language of the <em>Deus</em>, the language of god. Day and
      night, until he no longer thought in English but in god’s own tongue.
    </p>

    <p>
      He had thought that he had done it, after eighty years of continuous work
      in which he had no need to stop for sleep, and rarely had a need to eat.
      He had thought he understood the problem, that his code was not merely
      functional, but perfectly optimal. It was a mind boggling miscalculation,
      naivety on an order of magnitude he had not believed himself capable.
    </p>

    <p>
      The first attempt had been a colossal failure in spite, or perhaps because
      of, his certainty. On the second attempt he had lost his certainty, but he
      had still believed.
    </p>

    <p>
      Now, on his third attempt to mount God’s Seat, the caretaker has no hope
      for success. Some small part of him prays for a disaster however, a
      failing reactor or misaligned vein that would light the <em>Deus</em> in
      nuclear flames. Because while he can’t give up of his own volition, he
      would not complain if the choice was taken from him.
    </p>

    <p>
      And so, with shaking arms and the pressure of three centuries of
      loneliness upon him, he lay back on the simple black chair in the center
      of the room. For the third time he sat on God’s Throne.
    </p>

    <p>
      No dramatic lights or robotic voice turned on to signify the event. God’s
      Seat was instead activated by a sequence of neuro connected communications
      between the caretaker and the seat. This was not the transcription for
      which the super computer had been constructed, but merely a conversation
      held between the computer system and the caretaker that allowed him to
      control the system.
    </p>

    <p>
      Slowly but surely a low growl filled the air, the moon sized computer
      firing up systems that had not been activated for eighty eight years. This
      is a long wait; the computer double, triple, quadruple checks every
      diagnostic before reporting to the caretaker that it is ready.
    </p>

    <p>
      Hours have passed by the time the <em>Deus</em> is ready to activate. But
      what are hours to a man of centuries.
    </p>

    <p>He pauses, just slightly, before giving the final signal.</p>

    <h2 id="twelvehourslater">Twelve Hours Later</h2>

    <p>
      Failure. Failure once again. He had not expected to succeed in the
      slightest on this attempt, but somehow this was even worse than the
      previous two tries. There had been anomalies and errors on the first two.
      They had had him pouring over the logs for decades, painstakingly
      inspecting both reports and implementation for underlying flaws in the
      logic.
    </p>

    <p>
      But now the logs were clear. No obvious errors, no diagnostic reports of
      damage to the <em>Deus</em> interior. Yet he had nothing to show for his
      time in God’s Seat, nothing to show for three centuries of work, nothing
      to show for the consumption of a star.
    </p>

    <p>
      And the star’s energy was gone. Even the caretaker had never fully delved
      into the understanding of the Warp Ark; it had been completed before his
      time. Designed to port excess and disastrous energies outside the
      universe, or at least the known one, it was possible the <em>Deus</em> had
      not failed at all.
    </p>

    <p>
      Perhaps a new dual universe now existed, the star’s energy consumed to
      create both matter and its opposition and forging the universes of matter
      and anti-matter, complete with the worlds he had forged inside God’s Seat.
    </p>

    <p>
      It was possible, but a faint fantasy with irrelevant consequences. In all
      likelihood the star’s energy had been scattered uselessly into some
      unknowable void.
    </p>

    <p>
      The dismissal of this momentarily held fantasy was the last straw. For the
      first time in eighty eight years, the caretaker screamed. Rage, fury,
      failure, frustration, guilt, agony. All these emotions and more tore the
      scream from his throat and raised his fists in a brutal attack against the
      uncaring black walls.
    </p>

    <p>
      Had his throat held more biology than machinery he might have sounded
      hoarse or even been incapable of using his seldom used voice. But his
      scream rang loud and clear, the voice of a man in his prime.
    </p>

    <p>Two hours. That was how long his tantrum lasted.</p>

    <p>
      When it was over he was on the floor, holding himself tight and wishing he
      could cry. He had never had tear ducts, had never known what it was like
      to cry, yet still he felt it - the desire to cry.
    </p>

    <p>
      When he rose from the ground he was done wishing he could cry, but now he
      wished he could sleep. The caretaker had never known sleep, for the cold
      uncomfortable bleariness of hibe did not count.
    </p>

    <p>
      Twenty-four hours. An Earth day. That’s how long he would give himself.
      The first two attempts had taught him that rushed work after a devastating
      failure would only lead to more problems. And he needed a change in
      perspective, a break to allow him to slightly shift in neurological
      patterns and look at the situation in a new light.
    </p>

    <p>
      He slowly walks to the place that would best be described as his home,
      though he spends precious little time there. It is a short walk from God’s
      Seat, though his slow pace makes it feel long. Each of his steps drops
      heavily to the ground in the five earth gravities of the <em>Deus</em>’s
      exterior. A normal, unaltered human body would struggle under the
      conditions, but the caretaker’s body far outstripes even those of the holy
      men, who had built themselves to survive and thrive in the environment.
    </p>

    <p>
      There is nothing outwardly special about his home, just another living
      cell, one of the millions that the holy men used to fill. It is larger
      than most, but not particularly large.
    </p>

    <p>
      The room is clean; the only personality present is in the gradually formed
      marks of usage on the floor, walls, and table, for even the sturdy
      well-crafted living cells of the holy men will show wear after centuries
      of use.
    </p>

    <p>
      Two storage units incorporated into the wall on the far side of the door
      are what make this place home for the caretaker, or as much a home as he
      could have on this planet dwarfing machine. The first of the storage units
      held a collection of engineering oddities: outdated and antiquated
      fasteners that might be of use in the older sections of the machine,
      interesting and unique tools that had few applicable use cases with the
      modern state of the machine, and an old and varied assortment of computer
      hardware: microprocessors, motherboards, an array of LQE slot cards, and
      even a mixture of robotic equipment.
    </p>

    <p>
      The other storage unit contained the caretaker’s most prized possession, a
      collection of media from days long past and people long dead.
    </p>

    <p>
      Data on integral and operable systems on the machine was preserved by a
      varying number of backups and through an automated system that rewrote the
      data on a regular basis and a separate but complementary system that
      constantly inspected the state of the drives and repairs or replaces error
      containing drives. In short, the <em>Deus</em>’s data was perfectly
      preserved and maintained.
    </p>

    <p>
      Private information stores, however, did not have the same level, if any,
      against the inevitable creep of data corruption that occurs with time.
      Countless movies, shows, art records, books, knowledge, and milenia of the
      human experience lost.
    </p>

    <p>
      These things had seemed trivial when the fate of humanity had been in the
      hands of the holy men, but now their remnants formed one of the
      caretaker’s last tenuous handholds onto sanity.
    </p>

    <p>
      There were billions of cells and living clusters scattered about the{" "}
      <em>Deus</em>, and very very few held uncorrupted drives. The caretaker’s
      constructions and repairs had taken him across the entirety of the machine
      and had sent him searching for data stores everywhere, from private
      collections in isolated maintenance cells to the server databases of the
      dead recreational network that once ran throughout the <em>Deus</em>.
    </p>

    <p>
      He backed what he found to the maintained <em>Deus</em> network - the act
      was hardly illegal anymore and there were yottabytes of spare storage
      space on the system. The caretaker had kept the original drives out of
      sentiment; this was his one connection to humanity in a world of machines
      and though it was the data he had been searching for, these tenacious
      drives felt like a part of the humanity they contained.
    </p>

    <p>
      And so the last man alive laid sleepless in bed, century old images on the
      living quarters’ monitor and audio playing from the speakers behind his
      head. These moments were the only time where he saw human faces and heard
      human voices. He drowned his emotions in them in the following hours,
      losing himself in what had been and what had been created in the age of
      humanity.
    </p>
  </div>
);

export default one;
